"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconElectricityFilled = function IconElectricityFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "electricity"), _react.default.createElement("path", {
    d: "M23.85,28.5H11.5a.5.5,0,0,1-.38-.82l18-21.5a.5.5,0,0,1,.87.44L26.64,19.88a.5.5,0,0,0,.49.62H39.5a.5.5,0,0,1,.39.81c-2.83,3.54-14.1,17.62-18,22.51a.5.5,0,0,1-.87-.43l3.37-14.27A.51.51,0,0,0,23.85,28.5Z",
    fill: color
  }));
};

IconElectricityFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconElectricityFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconElectricityFilled;
exports.default = _default;